import React from "react";
import "./task-create.scss";
import Alert from "react-bootstrap/Alert";
import TaskReadyForApproval from "../../task-ready-for-approval/task-ready-for-approval";
import TaskCreatedStandard from "../../task-created-standard/task-created-standard";
import PropTypes from "prop-types";

const TaskCreateTop = ({
  alertConfig,
  setAlertConfig,
  showCreatedModal,
  showUseCase3,
  SetIsUseCase3Ready,
  setShowUseCase3,
  labels,
  onCreateAnother,
}) => {
  return (
    <>
      {alertConfig.showAlert && alertConfig.alertVariant !== "warning" && (
        <Alert
          show={alertConfig.showAlert}
          onClose={() =>
            setAlertConfig((prev) => ({
              ...prev,
              showAlert: false,
              alertAction: "",
              alertMessage: "",
              alertVariant: "",
            }))
          }
          variant={alertConfig.alertVariant}
          dismissible
        >
          <Alert.Heading>{alertConfig.alertAction}</Alert.Heading>
          <p>{alertConfig.alertMessage}</p>
          <hr />
        </Alert>
      )}
      {showUseCase3 && (
        <TaskReadyForApproval
          setReadyStatus={SetIsUseCase3Ready}
          show={showUseCase3}
          onHide={(e) => {
            setShowUseCase3(false);
          }}
          labels={labels}
        ></TaskReadyForApproval>
      )}
      {showCreatedModal && (
        <TaskCreatedStandard
          show={showCreatedModal}
          onHide={onCreateAnother}
          isSubtask={false}
          labels={labels}
        ></TaskCreatedStandard>
      )}
    </>
  );
};

TaskCreateTop.propTypes = {
  showCreatedModal: PropTypes.bool,
  showUseCase3: PropTypes.bool,
  SetIsUseCase3Ready: PropTypes.func,
  setShowUseCase3: PropTypes.func,
  alertConfig: PropTypes.object,
  setAlertConfig: PropTypes.func,
  onCreateAnother: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    ProjectSingular: PropTypes.string,
    ProjectPlural: PropTypes.string,
    ProjectSingularPossessive: PropTypes.string,
    ProjectPluralPossessive: PropTypes.string,
    TaskSingular: PropTypes.string,
    TaskPlural: PropTypes.string,
    TaskSingularPossessive: PropTypes.string,
    TaskPluralPossessive: PropTypes.string,
    FormSingular: PropTypes.string,
    FormPlural: PropTypes.string,
    FormSingularPossessive: PropTypes.string,
    FormPluralPossessive: PropTypes.string,
  }),
};
export default TaskCreateTop;
